if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"freya_label_ui","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^((268|456|77)1|3749|3854|473|6080|7258|8534)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}